import { render, staticRenderFns } from "./viewAdmin.vue?vue&type=template&id=8f725c94&scoped=true&"
import script from "./viewAdmin.vue?vue&type=script&lang=js&"
export * from "./viewAdmin.vue?vue&type=script&lang=js&"
import style0 from "./viewAdmin.vue?vue&type=style&index=0&id=8f725c94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f725c94",
  null
  
)

export default component.exports